import { API_ERROR_CODES, ONBOARDING_API_BASE_URL } from "./index.ts";

/**
 * Request to reset password for user
 */

export type ApiResetPasswordRequestResult = {
  data?: {
    requiresOtp: boolean;
  };
  errorCode?: API_ERROR_CODES;
  errorMessage?: string;
};

export const apiResetPasswordRequest = async (
  csrfToken: string,
  jid: string | null,
): Promise<ApiResetPasswordRequestResult> => {
  return fetch(`${ONBOARDING_API_BASE_URL}/auth/reset-password-request`, {
    method: "POST",
    body: JSON.stringify({ jid }),
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken,
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        const errorMessage = await response.text();
        return {
          errorCode: API_ERROR_CODES.GENERIC,
          errorMessage,
        };
      }

      const responseJson = await response.json();

      return { data: responseJson } as ApiResetPasswordRequestResult;
    })
    .catch(() => {
      return {
        errorCode: API_ERROR_CODES.GENERIC,
      };
    });
};
